import { ArticleSummary } from '../types/article';
import { publicIso, publicUrl } from './publicRecords';

export function articleSummaries(value: unknown, now = Date.now()): ArticleSummary[] {
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid article index');
    const result: ArticleSummary[] = [], ids = new Set<string>();
    for (const [year, months] of Object.entries(value)) {
        if (!/^\d{4}$/.test(year) || !months || typeof months !== 'object' || Array.isArray(months)) throw new Error('Invalid article year');
        for (const [month, entries] of Object.entries(months)) {
            if (!/^(0[1-9]|1[0-2])$/.test(month) || !Array.isArray(entries)) throw new Error('Invalid article month');
            for (const entry of entries) {
                if (!entry || typeof entry.id !== 'string' || !/^[a-zA-Z0-9_-]+$/.test(entry.id) || ids.has(entry.id)) throw new Error('Invalid article ID');
                ids.add(entry.id);
                if (entry.status && !['public', 'published'].includes(entry.status)) continue;
                const isSummary = entry.schemaVersion === 2;
                const stamp = isSummary ? entry.publishedAt : entry['公開日'];
                const publishedAt = publicIso(stamp);
                if (stamp != null && !publishedAt) throw new Error('Invalid article publication date');
                if (publishedAt && Date.parse(publishedAt) > now) continue;
                const detailUrl = `/?page=article&view=detail&year=${year}&month=${month}&id=${entry.id}`;
                const tags = isSummary ? entry.tags : entry.Tags || [];
                if (!Array.isArray(tags) || tags.some(tag => typeof tag !== 'string')) throw new Error('Invalid article tags');
                if (entry.schemaVersion !== undefined && !isSummary) throw new Error('Unsupported article summary version');
                if (isSummary && (typeof entry.title !== 'string' || typeof entry.excerpt !== 'string' || !publishedAt
                    || entry.detailUrl !== detailUrl || (entry.coverImage !== null && !publicUrl(entry.coverImage)))) throw new Error('Invalid article summary');
                result.push({ id: entry.id, year, month, publishedAt, tags,
                    excerpt: isSummary ? entry.excerpt : typeof entry.Excerpt === 'string' ? entry.Excerpt : undefined,
                    title: isSummary ? entry.title : undefined, coverImage: isSummary ? publicUrl(entry.coverImage) || undefined : undefined,
                    schemaVersion: isSummary ? 2 : undefined, detailUrl });
            }
        }
    }
    return result.sort((a, b) => (Date.parse(b.publishedAt as string) || 0) - (Date.parse(a.publishedAt as string) || 0) || a.id.localeCompare(b.id));
}
